import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 2 / -2;
  margin-bottom: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;
